export const sortByLabel = (listToSort) =>
  listToSort.sort((a, b) => {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  });

export const chunk = (array, columns) => {
  const chunkSize = Math.ceil(array.length / columns);
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export const getLinkList = (listOfLinks, numberOfColumns) => {
  const sortedLinks = listOfLinks?.length > 0 ? sortByLabel(listOfLinks) : [];
  const groupedLinks = chunk(sortedLinks, numberOfColumns);
  return groupedLinks?.length > 0 ? groupedLinks : [];
};
